// extracted by mini-css-extract-plugin
export default {"skillsBox":"mySkills_skillsBox__6dyJj","box":"mySkills_box__vD4Ng","card":"mySkills_card__lNHWT","cardImg":"mySkills_cardImg__X45CA"};